<template>
  <div class="find_home" style="background:#FF4D5A;padding-bottom:123px;widht:100%;overflow: hidden;">
    <gc-loading :is-show="loadingShow" />
    <gc-guide :down-show="downShow" @showDwon="getWechat" />
    <div class="banner" style="padding:0">
      <img v-lazy="banners" alt="">
    </div>
    <swiper
      slides-per-view="auto"
      :space-between="10"
      :loop="true"
      centered-slides="active"
      :pagination="{ clickable: true }"
      :autoplay="{ delay: 2000, disableOnInteraction: false }"
      :modules="modules"
    >
      <swiper-slide v-for="image in images" :key="image">
        <img v-lazy="image">
      </swiper-slide>
    </swiper>
    <div class="participate">
      <div class="participateTitle">如何参与</div>
      <ul>
        <li><img src="https://static.mingchu.co/webapp/findNew/imgs/Group6.png" alt=""></li>
        <li><img src="https://static.mingchu.co/webapp/findNew/imgs/Group7.png?1" alt=""></li>
        <li><img src="https://static.mingchu.co/webapp/findNew/imgs/Group8.png" alt=""></li>
      </ul>
      <div class="participatexian" />
      <div class="participateIcon">
        <img src="https://static.mingchu.co/webapp/findNew/imgs/GroupIcon.png" alt="">
        <img src="https://static.mingchu.co/webapp/findNew/imgs/GroupIcon.png" alt="">
        <img src="https://static.mingchu.co/webapp/findNew/imgs/GroupIcon.png" alt="">
      </div>
    </div>
    <div class="centen">
      <div class="task" style="padding-bottom:95px">
        <div class="taskTitle">打卡任务</div>
        <ul>
          <li>
            <div class="taskleft"><img src="https://static.mingchu.co/webapp/findNew/imgs/Group1.png" alt=""></div>
            <div class="taskright">
              <span>活动助力</span>
              <span>奖励：名厨 100 积分</span>
            </div>
          </li>
          <li>
            <div class="taskleft"><img src="https://static.mingchu.co/webapp/findNew/imgs/Group2.png" alt=""></div>
            <div class="taskright">
              <span>拜师学艺</span>
              <span>奖励：名厨 200 积分</span>
            </div>
          </li>
          <li>
            <div class="taskleft"><img src="https://static.mingchu.co/webapp/findNew/imgs/Group3.png" alt=""></div>
            <div class="taskright">
              <span>资讯学习</span>
              <span>奖励：名厨Market 优惠券</span>
            </div>
          </li>
          <li>
            <div class="taskleft"><img src="https://static.mingchu.co/webapp/findNew/imgs/Group4.png" alt=""></div>
            <div class="taskright">
              <span>佳作赏析</span>
              <span>奖励：加入名厨川菜交流群</span>
            </div>
          </li>
          <li>
            <div class="taskleft"><img src="https://static.mingchu.co/webapp/findNew/imgs/Group5.png" alt=""></div>
            <div class="taskright">
              <span>技艺比拼</span>
              <span>最终大奖&优作奖励</span>
            </div>
          </li>
        </ul>
        <div class="final">
          <div class="finaltop">
            <img src="https://static.mingchu.co/webapp/findNew/imgs/photo6.png" alt="">
            <span>最终大奖</span>
          </div>
          <div class="Ranking">技艺比拼前2名</div>
          <div class="finalbot">
            <div>寻味天府，食材探访</div>
            <div>与星厨同行，共赴三天两夜寻味天府之旅。</div>
          </div>
        </div>
        <div class="final" style="margin-top:35px;">
          <div class="finaltop">
            <img src="https://static.mingchu.co/webapp/findNew/imgs/photo7.png" alt="">
            <span>优作奖励</span>
          </div>
          <div class="Ranking">热度排名前20</div>
          <div class="finalbot">
            <div>天府食材，名厨周边</div>
            <div>完成全部任务且参加技艺比拼，热度排名前20的用户，可获得寻味天府同款食材包和名厨定制周边。</div>
          </div>
        </div>
      </div>
    </div>
    <div class="Judges">
      <div class="JudgesTitle">嘉宾评委</div>
      <div class="Judgescet" style="width:100%;text-align:center;">
        <span>完成任务参与比拼，上传川菜作品</span>
        <span>有机会获得嘉宾点评！</span>
      </div>
      <div class="Judges-user">
        <img src="https://static.mingchu.co/webapp/findNew/imgs/user.png" alt="">
        <div class="username">兰桂均</div>
        <div class="position">玉芝兰 / 兰亭永 主厨</div>
      </div>
      <div class="Judgesbot">
        <img src="https://static.mingchu.co/webapp/findNew/imgs/userbanner.png" alt="" style="width:100%;height:100%;">
        <div>我认为优秀的川菜传承者，首先要知自己，了解自己的烹饪能力；其次要知食材、懂本真；最后还要知食客，懂吃饭之人的需求和感受。</div>
      </div>
    </div>
    <LOGO color="#FF4D5A" />
    <div class="footer">
      <div class="footbtn">
        <img src="https://static.mingchu.co/webapp/findNew/imgs/help.png" alt="" @click="question">
        <div v-if="Number(new Date())/1000<Number(isSignup.end_time)" @click="Signup(1)">立即报名</div>
        <div v-else-if="isSignup.sign_status==0" @click="Signup(2)">作品合集</div>
      </div>
      <div v-if="Number(new Date())/1000<Number(isSignup.end_time)" class="footdata">
        活动时间：{{ isSignups.start_time }} - {{ isSignups.end_time }}
      </div>
      <div v-else-if="isSignup.sign_status==0" class="footdata">
        活动已结束，立即点击查看作品合集
      </div>
    </div>
    <ActionSheet :rule-show="userListShow" rule-title="常见问题" @onCancel="ruleCancel" />
    <ShareInfo :share-info="shareInfo" />
  </div>
</template>
<script>
import 'vant/lib/index.css'
import '@/style/scss/activity/findrule.scss'
import ShareInfo from '@/components/shareInfo.vue'

import { reactive, toRefs, onBeforeMount } from 'vue'
import { Pagination, Autoplay } from 'swiper'
import LOGO from '../components/bottomLogo'
import ActionSheet from '../components/actionSheet'
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue'
import { Toast } from 'vant'
import { ajaxHttp } from '@/api/api'
import gcLoading from '@/components/gc-loading'
import utils from '@/utils/utils'
import config from '@/config/config'
import { useRouter } from 'vue-router'
import { platformType } from '@/utils'

import 'swiper/swiper.min.css'
import 'swiper/modules/pagination/pagination.min.css'

export default {
  name: 'Home',
  components: {
    Swiper,
    SwiperSlide,
    LOGO,
    gcLoading,
    ActionSheet,
    ShareInfo
  },
  setup() {
    const router = useRouter()
    const state = reactive({
      downShow: false,
      shareInfo: { share_title: '闯关任务开启｜寻找川菜守“味”者', share_desc: '与星厨同行，共赴天府寻味之旅！', share_img: 'https://static.mingchu.co/webapp/findNew/share1.jpg', share_link: `${config.webapplink}/riseActivity/findNew/findshare?id=0` },
      banners: 'https://static.mingchu.co/webapp/findNew/imgs/banner.png',
      problemList: [{
        title: '1.如何参加活动？',
        content: '点击活动页面下方“立即报名”，按照顺序完成任务，每完成一项任务可获得对应热度值和任务奖励。'
      }, {
        title: '2.我可以不做「打卡任务」，只完成「技艺比拼」吗？',
        content: '参与者必须按照顺序完成所有任务之后才可以进入「技艺比拼」环节。'
      }, {
        title: '3.什么是名厨职业认证？',
        content: '名厨职业认证是用户在名厨App上的职业身份认证。用于证明用户的职业身份真实有效，也代表了名厨对用户职业身份的认可。目前名厨只提供对厨师用户的身份认证，经营者、美食爱好者和供应商无法进行职业认证。'
      }, {
        title: '4.如何进行职业认证？',
        content: '请到名厨App： 我的 →认证中心→职业认证，上传认证资料完成认证。'
      }, {
        title: '5.职业认证用户有什么专属活动权益？',
        content: '完成职业认证才可以进入「技艺比拼」环节的评选阶段，才有机会获得与星厨同行共赴寻味天府之旅的机会，没有完成认证的用户请抓紧时间进行哦！'
      }, {
        title: '6.上传菜品时需要注意什么？',
        content: '用户在「技艺比拼」环节上传的菜品，必须为原创，非原创者将取消参与评选的资格和热度榜排名。'
      }, {
        title: '7.获奖名单如何查看？',
        content: '获奖名单将于10月26日在本活动页和名厨App首页「今日」栏目进行公示。'
      }, {
        title: '8.任务奖励如何获取？',
        content: '用户完成任务所得积分、优惠券、天府食材包、名厨周边将在10月31日进行统一发放，获得天府食材包、名厨周边的用户可以在名厨App： 我的→我的订单→待收货，查看快递信息。'
      }, {
        title: '9.如何确保热度榜排名真实有效？',
        content: '如发现用户通过违规手段扰乱热度榜排名，经技术手段确认，名厨App有权取消该用户的排名和获奖资格。'
      }, {
        title: '10.免责声明',
        content: ['用户在参与活动时上传的菜品、灵感，主办方享有使用与其有关的图片、视频、文案、影像资料等进行营销宣传推广的权利；', '报名参与本活动即视为本人同意本活动各项规定，活动最终解释权归名厨App所有。']
      }],
      userListShow: false,
      loadingShow: true,
      isSignup: {
        sign_status: '',
        start_time: '',
        end_time: '',
        server_time: '',
        name_public_time: ''
      },
      isSignups: {
        start_time: '',
        end_time: ''
      }
    })
    onBeforeMount(() => {
      sensors.track('PlanVisit', {
        PlatformType: platformType(),
        page_type: 'sign'
      })
      // utils.hideShare()
      isSignup()
    })
    const images = [
      'https://static.mingchu.co/webapp/findNew/imgs/photo1.png',
      // 'https://static.mingchu.co/webapp/findNew/imgs/photo2.png',
      'https://static.mingchu.co/webapp/findNew/imgs/photo3.png',
      'https://static.mingchu.co/webapp/findNew/imgs/photo4.png',
      'https://static.mingchu.co/webapp/findNew/imgs/photo5.png'
    ]
    const isSignup = () => {
      ajaxHttp.$get(`/api/plan/index`).then(res => {
        if (res.code === 1) {
          state.isSignup = res.data
          if (res.data.sign_status === 1) {
            router.replace({ path: '/riseActivity/findNew/findhome' })
          } else {
            state.isSignups.start_time = formatTime(res.data.start_time)
            state.isSignups.end_time = formatTime(res.data.end_time)
            state.loadingShow = false
          }
        } else {
          state.loadingShow = false
          Toast(res.message)
        }
      })
    }
    const question = () => {
      state.userListShow = true
    }
    const formatTime = (str = 0) => { // 格式时间
      if (!str) { return '' }
      const date = new Date(parseInt(str) * 1000)
      const y = date.getFullYear()
      let m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      let d = date.getDate()
      d = d < 10 ? '0' + d : d
      return `${y}.${m}.${d}`
    }
    const Signup = (type) => {
      if (!utils.isGteatChefbrowser()) {
        const u = navigator.userAgent
        const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
        if (utils.is_weixn()) {
          if (!isAndroid) {
            utils.goDown('H5', `${config.webapplink}/riseActivity/findNew/findrule`)
          } else {
            state.downShow = true
          }
        } else {
          utils.goDown('H5', `${config.webapplink}/riseActivity/findNew/findrule`)
        }
      } else {
        if (type === 2) {
          router.replace({ path: '/riseActivity/findNew/worksList', query: { type: 0, page: 'rule' }})
        } else {
          sensors.track('PlanClick', {
            PlatformType: platformType(),
            type: 'clickSign'
          })
          utils.isLogin().then(res_login => { // app登陆状态
            const resLogin = JSON.parse(res_login)
            if (resLogin.data.is_login === 1) { // 登陆成功
              ajaxHttp.$post(`/api/plan/sign`).then(res => {
                if (res.code === 1) {
                // Toast('报名成功')
                  router.replace({ path: '/riseActivity/findNew/findhome', query: { top: '1' }})
                } else {
                  Toast(res.message)
                }
              })
            } else { // 没登录跳登录
              if (utils.isAndroid()) {
                location.href = `${config.webapplink}/login`
              } else {
                utils.login().then(res => {
                  location.reload()
                })
              }
            }
          })
        }
      }
    }
    const ruleCancel = () => {
      state.userListShow = false
    }
    return { ...toRefs(state), images, question, ruleCancel,
      modules: [Pagination, Autoplay], formatTime, Signup }
  }
}
</script>
<style>
.sheet_content{height: 517px;width: 311px;margin-left: 32px;margin-top: 16px; padding-bottom: 20px;}
.sheet_content div{width: 100%;}
.sheet_content div div:nth-child(1){font-size: 18px;font-weight: bold;color: #333333;display: block;}
.sheet_content div div:nth-child(2){font-size: 14px;color: #333333;padding-top: 4px;}
.sheet_content div div:nth-child(2) span{font-size: 14px;color: #333333;display: block;}
.sheet_content div div:nth-child(2) span:nth-child(2){padding-top:4px;padding-bottom: 20px;}
.sheet_degree{height: auto !important;}
.sheet_degree li{font-size: 14px;}
.mingchu{font-size: 14px;padding-top: 20px;}
.text-area{width: 100%; height: 54vh;}
.van-action-sheet__header{font-size: 18px !important;}
.van-action-sheet__close{color: #333;}
</style>
